<div *ngIf="isInEu == true">
  <div *ngIf="open != null">
    <div *ngIf="open == false">
      <p>Die Charts sind derzeit geschlossen. Bitte versuche es später nochmal.</p>
    </div>
    <div *ngIf="open == true">
      <h2>
        Japanradio Hit Countdown
      </h2>
      <form #checkboxForm="ngForm" class="charts-list">
        <div *ngIf="voteButtonVisible">
          <div *ngFor="let element of charts" class="charts-element-list">
            <label class="charts-element-label" for="{{element.id}}">
              <div class="charts-element">
                <div class="charts-element-position">{{element.position}}</div>
                <div class="charts-element-content">
                  <input class="checkbox" type="checkbox" id="{{element.id}}" [(ngModel)]="element.ticked"
                    [name]="element.id" />
                  <span>{{element.artist}} - {{element.name}}</span>
                  <span *ngIf="element.url"><a target="_blank" rel="noopener noreferrer" href="{{element.url}}"><img class="charts-element-player" src="./../assets/play.svg" /></a></span>
                </div>
              </div>

            </label>
          </div>
          <input *ngIf="consent" class="button" type="button" value="Für die Charts abstimmen!" (click)="sendVote()" />
          <div *ngIf="!consent" class="consent-message">Um für die Charts abstimmen zu können, wird eine eindeutige,
            anonyme
            ID-Nummer gespeichert. Diese lässt keine Rückschlüsse auf Dich, Dein Gerät, IP-Adresse oder sonstige
            Zuordnungsmerkmale zu und dient nur der Prävention mehrfacher Abstimmungen. Mit dem Klick auf
            "Einverstanden!"
            gibt Du uns die Zustimmung zur Speicherung dieser ID ausschließlich zu diesem Zweck.</div>
          <input *ngIf="!consent" class="button consent-button" type="button" value="Einverstanden!"
            (click)="giveConsent()" />
        </div>
        <div *ngIf="!voteButtonVisible && timeout">
          <p class="error-message">Die Charts konnten nicht geladen werden.</p>
        </div>
      </form>
      <h2>
        Newcomer vorschlagen
      </h2>
      <form class="newcomers-form">
        <div class="newcomers-input">
          <input type="text" [(ngModel)]="newcomer.name" name="newcomer.name" [value]="newcomer.name"
            placeholder="Titel" />
        </div>
        <div class="newcomers-input">
          <input type="text" [(ngModel)]="newcomer.artist" name="newcomer.artist" [value]="newcomer.artist"
            placeholder="Interpret" />
        </div>
        <div class="newcomers-button">
          <input class="button" type="button" value="Newcomer vorschlagen" (click)="sendNewcomer()" />
        </div>
      </form>

    </div>
  </div>
</div>
<div *ngIf="isInEu == false">
  This voting is only available in the EU.
</div>